<template>
  <div>
    <world-nav/>
    <b-form-group id="card" label="カード" class="form">
      <select-list
        :items="cardList"
        :fields="[
          { key:'icon', label:'' },
          { key:'name', label:'カード名', filterType:'string', filterKey:'name' },
          { key:'ctrl', label:'' }
        ]"
        :perPage="10"
        tableKey='RID'
        :selectable="true"
        tableClass='action-list'
      >
        <template v-slot:cell(icon)="row">
          <img class="t-card" :src="row.item.icon | coalesceImage">
        </template>
        <template v-slot:cell(name)="row">
          <template v-if="row.item.readonly">
            <router-link :to="{ path:`/impcard/${row.item.index}` }">
              {{ row.item.name }}
              <b-icon icon="eye-fill" class="" />
            </router-link>
          </template>
          <template v-else>
            <router-link :to="{ path:`/card/${row.item.index}` }">
              {{ row.item.name }}
              <b-icon icon="pencil-fill" class="" />
            </router-link>
          </template>
        </template>
        <template v-slot:cell(ctrl)="row">
          <a @click="cloneCard(row.item.index, row.item.readonly)">
            <b-icon icon="files" class="icon fa-1x m-1" />
          </a>
          <!-- <a @click="$delete(innerValue.area[row.item.location].quest, row.item.RID)">
            <font-awesome-icon icon="times" class="icon fa-1x m-1" />
          </a> -->
        </template>
      </select-list>
      <b-button size="sm"
        @click="addCard">
        <font-awesome-icon icon="plus-square" class="fa-1x p-0" />追加
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
// import store from '@/store'
import WorldNav from '@/components/WorldNav'
import SelectList from '@/components/SelectList'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
import { cards } from './mixin-editor'
export default {
  filters: {
    coalesceImage (image) {
      return image || './img/card/front.png'
    }
  },
  components: {
    WorldNav,
    SelectList
  },
  mixins: [mixinPlayer,cards],
  props: {
    value: Object,
    postMessage: Object,
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  methods: {
    addCard () {
      let id = '@'+_.uniqueId()
      this.innerValue.card.push([
        { '@extend': 'card/base'},
        { '@method': 'init',
          'args': {
            key: id,
            num: 1,
            max: 1
          },
          'call': 'card/base.init'
        },
        { '@method': 'info',
          'args': {
            'icon':null,
            'name':'名の無いカード',
            'memo':'',
            'type':'skill'
          },
          'call': 'card/base.info'
        },
        { '@method': 'prepare', 
          'code': [],
          'hook': []
        },
        { '@method': 'mix', 
          'code': [],
          'hook': ['card/mix.add-num']
        },
      ])
      this.$router.push({ path:`/card/${this.innerValue.card.length-1}` })
    },
    cloneCard (index, importCard) {
      let c
      if(importCard){
        c = _.cloneDeep(this.importCard[index])
      }else{
        c = _.cloneDeep(this.innerValue.card[index])        
      }
      c[1].args.key = '@'+_.uniqueId()
      c[2].args.name += '(copy)'
      this.innerValue.card.push(c)
    }
  },
  created () {
    this.$emit('changePlayer', 'n-player')
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.ctl {
  width: 40px;
}
.t-card {
  position: relative;
  width: 80px;
  height: 100px;
}
</style>
